import React from "react";
import CreateBookListForm from "./forms/CreateBookListForm";
import {createBookList, fetch_books} from "../action/books.js";
import {connect} from "react-redux";
import {FaCheckCircle} from "react-icons/fa";
import {Link} from "react-router-dom";

class CreateBookListPage extends React.Component{
    state={
        modal: false
    }
    submit = (data) => {
        this.setState({loading: true});
        this.props.createBookList(data)
            .then(msg => this.setState({modal: true, loading: false}));
        this.setState({data: data});
    }
    closeModal = () => {
        this.setState({modal:false});
        this.props.history.push("/main");
        window.location.reload();
    }
    render(){
        return(
            <div>
                {this.state.modal && (
                <div className="successc-modal-container">
                    <div className="successc-modal">
                        <FaCheckCircle  className="icon"/>
                        <h1> Congratulations </h1>
                        <h2> Booklist Created </h2>
                        <div>
                        <span className="insert_contents link text-white" onClick={this.closeModal}
                        onClick={this.closeModal}>Go Back To Dashboard</span>
                        </div>
                    </div>
                </div>)}
                <h1 className="content_title">Create Booklist</h1>
                {this.state.loading && (
                    <div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    )}
                {this.props.bookId !== undefined && 
                <CreateBookListForm submit={this.submit} bookId={this.props.bookId}/>}
            </div>
        );
    };
};


function mapStateToProps (state) {
    return {bookId: state.user.totalBooklists} 
}

export default connect(mapStateToProps, {createBookList, fetch_books})(CreateBookListPage);